import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Terms() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <section className="min-h-screen bg-appBg dark:bg-appDark py-4 px-6">

            <div className="max-w-6xl mx-auto">

                {/* TITLE */}
                <h1 className="text-4xl md:text-5xl font-bold text-titleLight dark:text-titleDark mb-10">
                    Terms & Conditions
                </h1>

                {/* CONTENT BOX */}
                <div className="bg-card dark:bg-cardDark rounded-[28px] border border-borderLight dark:border-borderDark p-8 md:p-10">

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        Welcome to{" "}
                        <Link to="/" className="text-blue-600 underline">
                            Online-Clipboard.in
                        </Link>. By accessing and using this website, you agree to comply with and be bound by the following terms and conditions.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Use of Service
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        This tool is provided for temporary text sharing between devices. You agree not to use this service for any illegal, harmful, or abusive purposes.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        User Responsibility
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        You are responsible for the content you share using this platform. We do not monitor or store your data permanently, and we are not responsible for any misuse of the shared information.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Data & Privacy
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        All shared data is stored temporarily and may be automatically deleted after a certain period. For more details, please visit our{" "}
                        <Link to="/privacy-policy" className="text-blue-600 underline">
                            Privacy Policy
                        </Link>.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Service Availability
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We strive to provide uninterrupted service, but we do not guarantee that the website will always be available or error-free.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Limitation of Liability
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8 mb-6">
                        We are not liable for any loss, damage, or issues resulting from the use of this service.
                    </p>

                    <h3 className="text-xl font-semibold text-titleLight dark:text-titleDark mt-6 mb-3">
                        Changes to Terms
                    </h3>

                    <p className="text-textMain dark:text-textDark leading-8">
                        We may update these terms at any time without prior notice. Continued use of the website means you accept the updated terms.
                    </p>

                </div>

                <Footer />

            </div>

        </section>
    );
}